import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import pt from './locales/pt-BR.json';

const savedLang = localStorage.getItem('mava_language') || 'es';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      'pt-BR': { translation: pt },
    },
    lng: savedLang,
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
  });

i18n.on('languageChanged', (lang) => {
  localStorage.setItem('mava_language', lang);
});

export default i18n;
